<template>
  <div class="overseas-container">
    <div class="overseas">
       <div class="banner">
          <div class="banner_img">
            <el-row class="job-title min-container">
              <el-col :span="24">
               {{ jobData.en_name }}
              </el-col>
            </el-row>
          </div>
       </div>
    </div>
    <div class="overseas-content">
      <div class="min-container">
        <div class="job-descript">
          <el-row>
            <el-col class="back-button">
              <img @click="back" :src="imageRoot + '/overseas/back_button.png'" alt="" srcset="">
            </el-col>
          </el-row>
           <el-row class="resp">
            <el-col class="title" :span="20">
              <p>Job Responsibilities</p>
            </el-col>
             <el-col class="subcontent" :span="20">
              <p
                v-for="(job_info, index) in jobInfoList"
                :key="index"
              >
                {{ job_info.trim() }}
              </p>
            </el-col>
          </el-row>
          <el-row class="req">
            <el-col class="title" :span="20">
              <p>Job Requirements</p>
            </el-col>
             <el-col class="subcontent" :span="20">
              <p
                v-for="(job_req, index) in jobReqList"
                :key="index"
              >
                {{ job_req.trim() }}
              </p>
            </el-col>
            <el-col :span='20'>
                <el-row
                  class='apply-button'
                >
                  <el-col :span="7">
                    <a href="hr@button-tech.co.uk ">
                      <img :src="imageRoot + '/overseas/apply_email_button.png'" alt="" srcset="">
                    </a>
                  </el-col>
                  <el-col :span="6">
                    <a target="_blank" href="https://uk.indeed.com/cmp/Button-Tech-UK-Limited-1/jobs">
                      <img :src="imageRoot + '/overseas/apply_website_button.png'" alt="" srcset="">
                    </a>
                  </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
         <a class="overseas-top-button" @click.prevent="scrollSeasToTop">
            <img :src="imageRoot + '/common/top_button.png'">
          </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      jobData: {},
      imageRoot: process.env.VUE_APP_IMAGE_PATH
    }
  },
  computed: {
    jobInfoList: function () {
      return (this.jobData.en_info) ? this.jobData.en_info.split('\n') : []
    },
    jobReqList: function () {
      return (this.jobData.en_require) ? this.jobData.en_require.split('\n') : []
    }
  },
  methods: {
    scrollSeasToTop () {
      window.scrollTo({ 'behavior': 'smooth', 'top': 0 })
    },
    back () {
      this.$router.push({ name: 'social' })
    }
  },
  created () {
    this.$axios.get('/admin/jobKiwi/jobPosition', { params: { job: this.$route.params.id } }).then(res => {
      if (res.status === 200 && res.data.code === 20000) {
        this.jobData = res.data.data[0]
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.overseas-top-button{
  @include topButton(97.5%);
  bottom: 80px;
}
</style>

<style lang="scss" scoped>
.overseas-content{
  @include backgroundImage(inline-block, 100%, fit-content, "#{$imageRoot}/overseas/BG.png", bottom, no-repeat, 100% auto, none);
  margin-bottom: -120px;
  background-color: #f5fbf5;
  padding-bottom: 4%;
}
.el-footer{
  margin-top:0 !important;
}
.job-descript{
  width: 100%;
  background-color: #ffffff;
  height: fit-content;
  position: relative;
  top: -180px;
  padding-top:10px;
  border-radius: 1%;
  box-shadow: 8px 8px 8px rgba(206,236,221,0.26);

}
.resp,
.req{
  .title{
    @include normalTitle('#{$imageRoot}/home/title_dot.png',45px, 45px, 67px, 54px, 10, 56.8px);
    p{
      left:107px;
    }
  }
}
.req{
  margin-top: 40px;
}
.subcontent{
  p{
    position:relative;
    left:107px;
    font-size: 16px;
    font-family: $fontFmaily;
    color:#636363;
    line-height: 28px;
  }
}
.back-button{
  img{
    width: 82px;
    height:28.38px;
    float: right;
    margin-right: 50px;
    margin-top:20px;
    cursor: pointer;
    @include hoverAnimation(1.06);
  }
}
.apply-button{
  cursor: pointer;
  padding: 80px 64px;
  img{
    @include hoverAnimation(1.06);
    width: auto;
    height: 45px;
  }
}
</style>

<style lang="scss" scoped>
  .min-container{
    @include minContainer;
  }

  .job-title{
    top:44%;
    //left:200px;
    text-align: center;
    font-family: $fontFmailyB;
    font-size: 40px;
    color:#ffffff
  }
</style>

<style lang="scss" scoped>
.overseas {
  position: relative;
  padding: 0px 0px 0px 0px;
  .banner {
    position: relative;
    height: 613px;
    .banner_img {
      @include backgroundImage(block, 100%, 613px, "#{$imageRoot}/overseas/topbanner.png", center top, no-repeat, auto 100%, none);
      img{
        position: relative;
        top:543px;
        left:39.5%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 1460px){
  .overseas-container{
    background-color: #f5fbf5;
  }
  .overseas-content{
    padding-bottom: 3% !important;
    height: fit-content !important;
  }
}
</style>
